import React from 'react';
import { Outlet } from 'react-router-dom';

const OrdersContent = () => {
  return <Outlet />;
};

export default OrdersContent;
